import { render } from "./AutoAdsDebug.vue?vue&type=template&id=2001d854&scoped=true"
import script from "./AutoAdsDebug.vue?vue&type=script&lang=js"
export * from "./AutoAdsDebug.vue?vue&type=script&lang=js"

import "./AutoAdsDebug.vue?vue&type=style&index=0&id=2001d854&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2001d854"]])

export default __exports__